// extracted by mini-css-extract-plugin
export default {"editCell":"RBanMgT5b3AGE19eFY6W","content":"QlpfFGMSCcYse7zJtDgX","wrapper":"xlC4O4PXyFEJHlSVXSvg","widthPlaceholder":"wjjumVfSMSS2uFhuX5C8","input":"FzEulKX9ZIgnZcx_gFeJ"};